import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatPrice' })
export class FormatPrice implements PipeTransform {
  transform(
    price: number,
    langCode: string,
    currency: string,
    currencySymbol: string,
    displayType: 'currency' | 'decimal' = 'currency',
  ): string {
    if (langCode && currency && typeof price === 'number') {
      if (displayType === 'decimal') {
        return price.toLocaleString(langCode, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      if (currency === 'BBD') {
        return price
          .toLocaleString(langCode, { style: 'currency', currency })
          .replace('$', 'BBD $');
      } else if (currency === 'XCD') {
        return price
          .toLocaleString(langCode, { style: 'currency', currency })
          .replace('$', 'XCD')
          .replace('EC', '');
      } else {
        return price
          .toLocaleString(langCode, { style: 'currency', currency })
          .replace(currency, currencySymbol);
      }
    }
    return '';
  }
}
